import React, { useEffect, useState } from 'react';
import { Checkbox, FormField, IconButton, Loader, RadioGroup } from '@wix/design-system';
import { DateFormat, NAME_FORMATS_ORDER, NAME_FORMAT_LABELS, NameFormat } from '../models/shared/Settings';
import Slider from 'rc-slider';
import { useSettingsContext } from '../context/SettingsContext';



const DateOptions: DateFormat[] = ['DD/MM/YYYY', 'MM/DD/YYYY', 'Hide'];
const DEFAULT_SIZE = 1;
const DEFAULT_SPEED = 1;
const DEFAULT_TEXT_SIZE = 1;

export default function BaseSettings() {
    const { settings, updateSettings, processing } = useSettingsContext();
    const choosenDateFormat: DateFormat = settings?.dateFormat || 'DD/MM/YYYY';
    const choosenNameFormat: NameFormat = settings?.nameFormat || 'full';
    const [speed, setSpeed] = useState(DEFAULT_SPEED);
    const [size, setSize] = useState(DEFAULT_SIZE);
    const [textSize, setTextSize] = useState(DEFAULT_TEXT_SIZE);

    useEffect(() => {
        if (settings?.speed) {
            setSpeed(settings.speed);
        }
        if (settings?.size) {
            setSize(settings.size);
        }
        if (settings?.textSize) {
            setTextSize(settings.textSize);
        }
    }, [settings])


    return (
        <>
            <hr />
            <div className='section'>
                <FormField suffix={processing && <Loader size='tiny' />} label="Minimal Star Count"
                    infoContent='Choose minimal star count to display reviews'
                >
                    <div className='mt-1'>
                        {[1, 2, 3, 4, 5].map(star => <IconButton key={star}
                            skin={settings?.minStarCount === star ? 'standard' : 'light'}
                            onClick={() => updateSettings({ minStarCount: star })}
                            disabled={processing}
                        >
                            <>{star}</>
                        </IconButton>)}
                    </div>
                </FormField>
            </div>

            <div className='section'>
                <FormField label="Review Date" suffix={processing && <Loader size='tiny' />}
                    infoContent='Choose how or if to display each review date'
                >
                    <RadioGroup
                        value={choosenDateFormat}
                        onChange={(value) => updateSettings({ dateFormat: value as DateFormat })}

                    >
                        {DateOptions.map(value => <RadioGroup.Radio key={value} value={value}>{value}</RadioGroup.Radio>)}

                    </RadioGroup>
                </FormField>
            </div>
            <div className='section'>
                <FormField label="Reviewer Name" suffix={processing && <Loader size='tiny' />}
                    infoContent='Choose how to display the reviewer name'
                >
                    <RadioGroup
                        value={choosenNameFormat}
                        onChange={(value) => updateSettings({ nameFormat: value as NameFormat })}
                    >
                        {NAME_FORMATS_ORDER.map(value => <RadioGroup.Radio key={value} value={value}>{NAME_FORMAT_LABELS[value]}</RadioGroup.Radio>)}
                    </RadioGroup>
                </FormField>
            </div>
            <div className='section'>
                <FormField suffix={processing && <Loader size='tiny' />} label="Speed"
                    infoContent='Set speed and direction of the reviews animation'
                >

                    <div className='mt-1 mx-1'>
                        <Slider
                            min={-2}
                            max={2}
                            step={0.05}
                            value={-speed}
                            onChangeComplete={(value) => updateSettings({ speed: -Number(value) || 0.01 })}
                            onChange={(value) => setSpeed(-value)}
                            disabled={processing}
                        />
                    </div>
                </FormField>
            </div>
            <div className='section'>
                <FormField suffix={processing && <Loader size='tiny' />} label="Height"
                    infoContent='Set heigt of review boxes'
                >

                    <div className='mt-1 mx-1'>
                        <Slider
                            min={1}
                            max={2.5}
                            step={0.05}
                            value={size}
                            onChangeComplete={(value) => updateSettings({ size: Number(value) })}
                            onChange={(value) => setSize(Number(value))}
                            disabled={processing}
                        />
                    </div>
                </FormField>
            </div>
            <div className='section'>
                <FormField suffix={processing && <Loader size='tiny' />} label="Text Size"
                    infoContent='Set size of the review and author text'
                >

                    <div className='mt-1 mx-1'>
                        <Slider
                            min={0.7}
                            max={1.5}
                            step={0.05}
                            value={textSize}
                            onChangeComplete={(value) => updateSettings({ textSize: Number(value) })}
                            onChange={(value) => setTextSize(Number(value))}
                            disabled={processing}
                        />
                    </div>
                </FormField>
            </div>
            <div className='section'>
                <FormField suffix={processing && <Loader size='tiny' />} label="Advance Settings">
                    <div className='ms-2'>
                        <div>
                            <Checkbox
                                checked={settings?.textReviewsOnly || false}
                                onChange={() => updateSettings({ textReviewsOnly: !settings?.textReviewsOnly })}
                                tooltipContent='Only show reviews with text'
                            >
                                Text Reviews Only
                            </Checkbox>
                        </div>
                        <div>

                            <Checkbox
                                onChange={() => updateSettings({ randomOrder: !settings?.randomOrder })}
                                checked={settings?.randomOrder || false}
                                tooltipContent='Show reviews in random order instead of latest'
                            >
                                Random Order
                            </Checkbox>
                        </div>
                    </div>
                </FormField>

            </div>
        </>
    );
}
